import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./../../styles/accueil/MesCommandes.css";

function MesCommandes() {
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [client, setClient] = useState({});
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const resetFilters = () => {
  setDateDebut("");
  setDateFin("");
};


  const formatPrix = (valeur) => {
  if (!valeur) return "0 Ar";
  return Number(valeur).toLocaleString("fr-FR", { minimumFractionDigits: 0 }).replace(/\s/g, ".") + " Ar";
};


  const genererPDF = (commande) => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.setTextColor(21, 128, 61);
    doc.text("Historique de la commande", 105, 15, { align: "center" });

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Nom du client : ${client.nom || "—"} ${client.prenom || ""}`, 14, 30);
    doc.text(`Email : ${client.email || "—"}`, 14, 38);
    doc.text(`Entreprise : ${client.company || "Ma Société"}`, 14, 46);

    const ligneCommande = 54;
    doc.text(`Commande n°: ${commande.id}`, 14, ligneCommande);
    doc.text(
      `Date: ${
        commande.date_paiement
          ? new Date(commande.date_paiement).toLocaleDateString("fr-FR")
          : "—"
      }`,
      14,
      ligneCommande + 8
    );
    doc.text(`Référence: ${commande.reference || "—"}`, 14, ligneCommande + 16);
    doc.text(`Montant total: ${formatPrix(commande.montant)}`, 14, ligneCommande + 24);

    const tableColumn = ["Produit", "Catégorie", "Quantité", "Unité", "Prix unitaire"];
    const tableRows = [];

    if (commande.produits && commande.produits.length > 0) {
      commande.produits.forEach((p) => {
        tableRows.push([
          p.titre || "Produit",
          p.categorie || "—",
          p.quantite || 1,
          p.unite || "",
          formatPrix(p.prix_unitaire),
        ]);
      });
    }

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 90,
      theme: "grid",
      headStyles: { fillColor: [21, 128, 61] },
      styles: { fontSize: 10 },
    });

    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `commande_${commande.id}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    const fetchCommandes = async () => {
      try {
        const clientData = JSON.parse(localStorage.getItem("clientConnecte")) || {};
        setClient(clientData);

        if (!clientData.email) {
          setMessage("Client non connecté.");
          setLoading(false);
          return;
        }

        const res = await fetch(`http://localhost:5000/api/commande/client/${clientData.email}`);
        const data = await res.json();

        if (res.ok) {
          const toutes = data.sort(
            (a, b) =>
              new Date(b.date_paiement || b.createdAt) -
              new Date(a.date_paiement || a.createdAt)
          );
          setCommandes(toutes);
        } else {
          setMessage("Erreur lors du chargement de l'historique.");
        }
      } catch (err) {
        console.error(err);
        setMessage("Erreur lors du chargement de l'historique.");
      } finally {
        setLoading(false);
      }
    };

    fetchCommandes();

    const handleClientUpdated = () => {
      setLoading(true);
      fetchCommandes();
    };

    window.addEventListener("clientUpdated", handleClientUpdated);
    return () => window.removeEventListener("clientUpdated", handleClientUpdated);
  }, []);

  if (loading) return <p className="loading">Chargement...</p>;

  // 🔹 Filtrer par date
  const commandesFiltres = commandes.filter((cmd) => {
    const dateCmd = cmd.date_paiement ? new Date(cmd.date_paiement) : new Date(cmd.createdAt);
    const start = dateDebut ? new Date(dateDebut) : null;
    const end = dateFin ? new Date(dateFin) : null;

    if (start && dateCmd < start) return false;
    if (end && dateCmd > end) return false;
    return true;
  });

  return (
    <div className="historique-container">
      <h2 className="historique-title">📜 Historique de mes commandes</h2>

      {message && <p className="message-erreur">{message}</p>}

      {/* 🔹 Filtres */}
      <div className="filtres-container">
        <label>
          Date de début :
          <input type="date" value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} />
        </label>

        <label>
          Date de fin :
          <input type="date" value={dateFin} onChange={(e) => setDateFin(e.target.value)} />
        </label>

        <button
            onClick={resetFilters}
            className="btn-clear-filter"
          >
            🔄 Réinitialiser
          </button>

      </div>

      {/* 🔹 Affichage */}
      {commandesFiltres.length === 0 ? (
        <p className="aucun-historique">Aucune commande dans cette période.</p>
      ) : (
        <table className="commandes-table">
          <thead>
            <tr>
              <th>Référence</th>
              <th>Date</th>
              <th>Montant total</th>
              <th>Produits</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {commandesFiltres.map((cmd) => (
              <tr key={cmd.id}>
                <td>{cmd.reference || "—"}</td>
                <td>{cmd.date_paiement ? new Date(cmd.date_paiement).toLocaleDateString("fr-FR") : "—"}</td>
                <td>{formatPrix(cmd.montant)}</td>
                <td>
                  {cmd.produits && cmd.produits.length > 0 ? (
                    <ul className="produits-list-table">
                      {cmd.produits.map((p, i) => (
                        <li key={i}>
                          {p.titre || "Produit"} ({p.categorie || "—"}) — {p.quantite || 1} {p.unite || ""} × {formatPrix(p.prix_unitaire)}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <em>Aucun produit</em>
                  )}
                </td>
                <td>
                  <button className="btn-pdf" onClick={() => genererPDF(cmd)}>
                    📄 Télécharger PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default MesCommandes;
